import * as particles from "pixi-particles";
import { ParticleConfig } from "slotworks/config/component-config-schema";
import { AnimatedParticleConfig } from "slotworks/config/component-config-schema";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import DeviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";

class ParticleManager {

    private configs: Map<string, ParticleConfig>;

    private lastTime: number;
    private emitters: Map<number, particles.Emitter> = new Map<number, particles.Emitter>();

    private emitterId: number = 0;

    constructor() {
        this.configs = new Map<string, ParticleConfig>();
    }

    public addConfig(id: string, config: ParticleConfig) {
        this.configs.set(id, config);
    }

    public add(id: string, position: Point, container: PIXI.Container): number {

        this.emitterId++;

        const config = this.configs.get(id);

        const processedTextures = config.textures.map((asset: string | AnimatedParticleConfig): any => {
            if (typeof asset === "string") {
                return GraphicsManager.getTexture(asset);
            } else {
                const processedFrames = asset.textures.map((frame: string) => GraphicsManager.getTexture(frame));
                return {
                    framerate: asset.framerate,
                    loop: asset.loop,
                    textures: processedFrames
                };
            }
        });

        if (DeviceInfo.isPhone) {
            let cappedParticles = config.config.maxParticles;
            if (cappedParticles > 50) {
                cappedParticles = 50 + (cappedParticles - 50) * 0.5;
            }
            config.config.maxParticles = cappedParticles;
        }

        const emitter = new particles.Emitter(
            container,
            processedTextures,
            config.config
        );

        if (typeof processedTextures[0] !== "string") {
            emitter.particleConstructor = particles.AnimatedParticle;
        }

        emitter.updateSpawnPos(position.x, position.y);

        this.emitters.set(this.emitterId, emitter);
        emitter.addAtBack = false;
        emitter.emit = true;

        return this.emitterId;
    }

    public remove(id: number) {
        const emitter = this.emitters.get(id);
        emitter.emit = false;
        emitter.destroy();
        this.emitters.delete(id);
    }

    public update(time: number) {
        if (this.lastTime) {
            this.emitters.forEach((emitter: particles.Emitter) => {
                emitter.update((time - this.lastTime) * 0.001);
            });
        }

        this.lastTime = time;
    }

    public get(id: number) {
        return this.emitters.get(id);
    }
}

export default new ParticleManager();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/particles/particle-manager.ts